
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import prettyBytes from 'pretty-bytes';
import { Attachment } from '@/types';

@Component
export default class AttachmentSize extends Vue {
  @Prop(Object) readonly attachment!: Attachment

  get sizeLong(): string {
    return prettyBytes(this.attachment.size, { locale: 'it' });
  }
}
